module.exports = __webpack_public_path__ + "assets/4d242305367cca3546a5a009fe603e4e.png";